import { TemplateType } from 'app/features/contest/models/contest-template.models';

export const novonordiskTemplate: TemplateType = {
  firstTable: [
    { id: 'position', label: 'Pos.' },
    { id: 'gender', label: 'Sexe' },
    { align: 'left', id: 'full_name', label: 'Nom' },
    { id: 'metrics' },
    { id: 'customField' },
  ],
  hasTwoTables: true,
  header: {
    banner: null,
    displayActivityInfo: true,
  },
  secondTable: [
    { id: 'date', label: 'Date' },
    { id: 'gender', label: 'Sexe' },
    { align: 'left', id: 'full_name', label: 'Nom' },
    { id: 'metrics' },
    { id: 'customField' },
  ],
  metrics: {
    available: ['ppr', 'wpk'],
    default: 'ppr',
  },
  theme: {
    primaryColor: '#ffffff',
    secondaryColor: '#e8e8e8',
    textColor: '#000000',
  },
};
